angular.module("dx.webapp.grade", [
	"dx.webapp.angular",
	"dx.ui.dataTypes.grading",
]);
